import {
  IAdvancedStore,
  injectAsyncReducer,
  injectAsyncSaga,
} from '@mihanizm56/redux-core-modules';
import { Router } from 'router5';
import {
  setModalAction,
  notificationsState,
  NOTIFICATIONS_REDUCER_NAME,
} from '@wildberries/notifications';
import {
  confirmModalModuleReducer,
  confirmModalWatcherSaga,
  CONFIRM_MODALS_REDUCER_NAME,
  CONFIRM_MODAL_SAGA_NAME,
} from '@wildberries/confirm-modal-portal';
import { preloadFonts } from '@/_utils/load-style';

export const registrationDependencies = ({
  store,
  router,
}: {
  store: IAdvancedStore;
  router: Router;
}) => {
  store.setDependencies({
    setModalAction,
  });
  router.setDependencies({
    setModalAction,
  });
};

export const registrationSaga = ({ store }: { store: IAdvancedStore }) => {
  injectAsyncSaga({
    store,
    name: CONFIRM_MODAL_SAGA_NAME,
    saga: confirmModalWatcherSaga,
    isRoot: true,
  });
};

export const registrationReducer = ({ store }: { store: IAdvancedStore }) => {
  injectAsyncReducer({
    store,
    name: NOTIFICATIONS_REDUCER_NAME,
    reducer: notificationsState,
    isRoot: true,
  });
  injectAsyncReducer({
    store,
    name: CONFIRM_MODALS_REDUCER_NAME,
    reducer: confirmModalModuleReducer,
    isRoot: true,
  });
};

export const registrationActions = () => {
  preloadFonts();
};
